import { DataService } from "./data.service";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Url } from "../common/url";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class QavisitService extends DataService {
  constructor(http: HttpClient, private localHttp: HttpClient) {
    super("qavisit", http);
  }

  url: string = Url.qavisit;

  getAllResources(
    powertrainId?: string,
    isVisitReviewed?: boolean,
    skip: number = 0,
    limit: number = 25,
    dateFrom: Date = null,
    dateTo: Date = null,
    status: number = null
  ) {
    let fields = `&filter[fields]=date&filter[fields]=timein&filter[fields]=timeout&filter[fields]=supervisor&filter[fields]=reviewed&filter[fields]=accountId&filter[fields]=reviewerId&filter[fields]=trainno&filter[fields]=powertrainId&filter[fields]=created&filter[fields]=updated&filter[fields]=id`;

    let ptId =
      powertrainId && powertrainId != "null"
        ? "&filter[where][powertrainId]=" + powertrainId
        : "";
    let stat = status ? "&filter[where][status]=" + status : "";

    let filterInclude =
      "&filter[include]=powertrain&filter[include]=addedBy&filter[include]=reviewedBy&filter[order]=id DESC";
    let isReviewed = isVisitReviewed ? "&filter[where][reviewed]=true" : "";
    let dateSearch =
      dateFrom && dateTo
        ? `&filter[where][date][between][0]=${dateFrom}&filter[where][date][between][1]=${dateTo}`
        : "";
    let fDate =
      dateFrom && !dateTo ? `&filter[where][date][gt]=${dateFrom}` : "";
    let tDate = dateTo && !dateFrom ? `&filter[where][date][lt]=${dateTo}` : "";
    let limit25 = `?filter[limit]=${limit}&filter[skip]=${skip}`;
    let limitGreaterThan25 = `?filter[limit]=${limit}&filter[skip]=${skip}&filter={"fields":${fields}}`;
    let filterLimit = limit <= 25 ? limit25 : limitGreaterThan25;

    return this.localHttp.get(
      this.url +
        filterLimit +
        isReviewed +
        ptId +
        stat +
        filterInclude +
        fDate +
        tDate +
        dateSearch
    );
  }

  getAllResourcesCount(
    powertrainId?: string,
    isVisitReviewed?: boolean,
    dateFrom: Date = null,
    dateTo: Date = null,
    status: number = null
  ) {
    let ptId =
      powertrainId && powertrainId != "null"
        ? "&where[powertrainId]=" + powertrainId
        : "";

    let stat = status ? "&where[status]=" + status : "";
    let isReviewed = isVisitReviewed ? "?where[reviewed]=true" : "?";
    let dateSearch =
      dateFrom && dateTo
        ? `&where[date][between][0]=${dateFrom}&where[date][between][1]=${dateTo}`
        : "";
    let fDate = dateFrom && !dateTo ? `&where[date][gt]=${dateFrom}` : "";
    let tDate = dateTo && !dateFrom ? `&where[date][lt]=${dateTo}` : "";
    return this.localHttp.get(
      `${this.url}/count` +
        isReviewed +
        ptId +
        fDate +
        tDate +
        dateSearch +
        stat
    );
  }

  getByVisitId(visitId: string) {
    return this.localHttp.get(this.url + "?filter[where][visitId]=" + visitId);
  }

  cancelChanges(visit: any) {
    visit.reviewed = false;
    visit.reviewerId = null;
    return this.localHttp.put(this.url + "/" + visit.id, visit);
  }

  deleteQAVisisNotAcceptedPoints(visitId: string) {
    return this.localHttp.delete(`${this.url}/${visitId}/qavisitpoints`);
  }

  getAll(): Observable<Object> {
    return this.localHttp.get(
      "http://localhost:3002/api/qavisits?filter[where][reviewed]=true&filter[include]=powertrain&filter[limit]=1000&filter[skip]=6000"
    );
  }
}
